var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.198 5.03c1.917 0 7.744 4.57 10.798 7.172.227.194.23.541.01.743l-1.258 1.153a.5.5 0 0 1-.676 0l-1.35-1.237a.5.5 0 0 0-.658-.014l-4.28 3.567a.3.3 0 0 1-.49-.185l-.203-1.326a.6.6 0 0 1 .2-.544l3.146-2.735a.487.487 0 0 0-.025-.762c-.867-.637-2.146-1.476-2.7-1.476-.837 0-1.842 2.177-1.674 6.699.167 4.522 1.004 5.862 1.674 5.862.67 0 2.345-.67 10.887-7.872C25.138 6.871 27.65 5.364 28.823 5.03 29.995 4.693 31 7.205 31 14.575c0 7.369-.167 10.718-1.842 11.723-1.286.77-7.716-4.156-11.143-7.022a.496.496 0 0 1-.03-.732l1.14-1.14a.5.5 0 0 1 .67-.035c1.891 1.528 5.3 4.197 6.18 4.575 1.173.502 1.843-2.01 2.01-6.532.168-4.522-.837-5.36-1.507-5.694-.67-.336-3.517 1.17-10.551 7.368-7.034 6.197-11.054 9.044-13.064 9.211-1.608.133-1.898-6.756-1.842-10.217C.91 12.398 1.19 5.029 3.2 5.029z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxs);
export default __webpack_public_path__ + "static/media/AXS.cce79a067188ba9f0dbbf469a294307a.svg";
export { ForwardRef as ReactComponent };